/**
 * How It Works Store
 * Handles nearest store detection and display for the How It Works Store section.
 */

function howItWorksStore() {
  const c = {
    dom: {
      section: 'hiw-store__section',
      storeLink: 'js-hiw-store-link',
      nearest: 'js-hiw-store-nearest',
      nearestLink: 'js-hiw-store-nearest-link',
      fallback: 'js-hiw-store-fallback',
    },
    cls: {
      hide: 'hide',
    },
  };

  const $sections = document.querySelectorAll(`.${c.dom.section}`);

  function init() {
    if (!$sections.length) return;

    $sections.forEach(($section) => {
      const enableNearest = $section.dataset.enableNearestStore === 'true';

      if (!enableNearest) return;

      initNearestStore($section);
    });
  }

  function initNearestStore($section) {
    const storage = window.sessionStorage;
    const nearestStoreJson = storage?.getItem('nearestStoresData');
    const nearestStores = nearestStoreJson ? JSON.parse(nearestStoreJson) : null;

    if (nearestStores?.length) {
      displayNearestStore($section, nearestStores[0]);
    }

    // Listen for updates from the store locator
    window.addEventListener('nearestStoresUpdated', (e) => {
      const { stores } = e.detail || {};

      if (stores?.length) {
        displayNearestStore($section, stores[0]);
      }
    });
  }

  function displayNearestStore($section, store) {
    if (!store) return;

    const $nearest = $section.querySelector(`.${c.dom.nearest}`);
    const $nearestLink = $section.querySelector(`.${c.dom.nearestLink}`);
    const $fallback = $section.querySelector(`.${c.dom.fallback}`);

    if (!$nearest || !$nearestLink) return;

    const storeName = store.name;
    const handleizedStoreName = __.handleize(storeName);

    $nearestLink.href = `/pages/${handleizedStoreName}`;
    $nearestLink.title = storeName;
    $nearestLink.textContent = storeName;

    __.removeClass($nearest, c.cls.hide);

    if ($fallback) {
      __.addClass($fallback, c.cls.hide);
    }
  }

  return init();
}

export default howItWorksStore;
